import { Button, Divider, Space } from 'antd'
import Management from 'components/general/Management'
import { exportToExcel } from 'general_function';
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom';

const layout = [
    [{ label: "Tên bài học", name: "name", type: "input", rules: [{ required: true }] }],
    [{ label: "Mô tả", name: "description", type: "textarea", rules: [{ required: true }] }],
];

export default function LessonList({ course, loadCourse }) {
    const navigate = useNavigate();

    const fetchLessons = useCallback(async () => {
        const allLessons = course?.lessons || [];
        return {
            data: allLessons,
            total: allLessons.length,
        };
    }, [course]);

    const handleExport = useCallback(() => {
        const data = course?.lessons || [];
        exportToExcel(data, `lesson_list_course_${course.id}`, ["name", "description"]);
    }, [course]);

    return <>
        <Divider orientation="left">Danh sách bài học</Divider>

        <Management
            layout={layout}
            apiPath="/lessons/"
            itemName="bài học"
            listMode="card"
            fetchData={fetchLessons}
            useFrontendPagination
            additionalPostData={{ course: course.id }}
            onReload={loadCourse}
            disableSearch
            onCardClick={(item) => navigate(`/university-lessons/${item.id}`)}
            defaultLogo={process.env.PUBLIC_URL + '/img/standard-logo.png'}
            actions={(
                <Space wrap>
                    <Button type="primary" onClick={handleExport}>Tải danh sách</Button>
                </Space>
            )}
        />
    </>
}
